import * as R from 'ramda';
import React from 'react';
import {compose, mapProps, withContext}  from 'recompose';

export function withContextFromProps(...contextTypes) {
  return compose(
    ...contextTypes.map(context =>
      withContext(context, R.pick(R.keys(context)))
    )
  );
}

export const JustRenderChildren = mapProps(R.pick(["children"]))(React.Fragment);



// WEBPACK FOOTER //
// ./modules/issFrontend/utils/context.js